import Box from '@mui/material/Box';
import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock, MetaLine } from '../activityFeedHeaderShared';

function GroupMembershipChangedHeader({ entity, item, activity }) {
  return (
    <HeaderBlock
      primary={<DefaultPrimaryHeader label={entity?.name || entity?.groupId} activity={activity} />}
      secondary={
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          {!!entity.membersAdded?.length && <MetaLine>{`Added: ${entity.membersAdded.join(', ')}`}</MetaLine>}
          {!!entity.membersRemoved?.length && <MetaLine>{`Removed: ${entity.membersRemoved.join(', ')}`}</MetaLine>}
          <DescriptionSecondary item={item} />
        </Box>
      }
    />
  );
}

export default GroupMembershipChangedHeader;
